module.exports = __webpack_public_path__ + "ty7-20a696e2.png";